import { useSelector } from 'react-redux';

const useAdminCheck = () => {
      const auth = useSelector((state) => state.auth);

      if (auth?.accessToken && auth?.user && auth?.user?.role === 'admin') {
        return true;
      } else {
        return false;
      }
};

export default useAdminCheck;